export const ThemeColor6 = [
  "#1677ff",
  "#39c8ae",
  "#c781fb",
  "#f68773",
  "#feaa4a",
  "#ed6dc6",
];
